/**
 * 归一化圆弧起止角度，返回一致的起止角和弧度范围。
 * @param startAngle 起始角度（弧度）。
 * @param endAngle 终止角度（弧度）。
 * @param clockwise 是否顺时针方向。
 * @returns 归一化后的起止角和弧度范围。
 */
export function normalizeArcAngles(
    startAngle: number,
    endAngle: number,
    clockwise: boolean,
): { start: number; end: number; angleRange: number } {
    const start = startAngle;
    let end = endAngle;
    if (clockwise) {
        if (end > start) {
            end -= Math.PI * 2;
        }
        const angleRange = start - end;
        return { start, end, angleRange };
    }
    if (end < start) {
        end += Math.PI * 2;
    }
    const angleRange = end - start;
    return { start, end, angleRange };
}
